import styled from '@emotion/styled';

interface LineProps {
  color?: string;
  thickness?: string;
  borderRadius: string;
  size?: string;
}

export const Line = styled.div<LineProps>({}, props => ({
  background: props.color,
  borderRadius: props.borderRadius,
  height: props.thickness,
  width: props.size,
}));

export const Container = styled.div({
  height: '50px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0px 4px',
});
